var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1922_5331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.435 0H4.5625C3.56794 0 2.61411 0.395088 1.91085 1.09835C1.20759 1.80161 0.8125 2.75544 0.8125 3.75V14.25C0.8125 15.2446 1.20759 16.1984 1.91085 16.9016C2.61411 17.6049 3.56794 18 4.5625 18H19.435C20.4296 18 21.3834 17.6049 22.0867 16.9016C22.7899 16.1984 23.185 15.2446 23.185 14.25V3.75C23.185 2.75544 22.7899 1.80161 22.0867 1.09835C21.3834 0.395088 20.4296 0 19.435 0ZM16.015 9.99L9.86125 13.29C9.69763 13.3783 9.51468 13.4247 9.32875 13.425C9.03038 13.425 8.74423 13.3065 8.53326 13.0955C8.32228 12.8845 8.20375 12.5984 8.20375 12.3V5.7C8.20392 5.50552 8.25451 5.3144 8.35057 5.1453C8.44664 4.9762 8.5849 4.83489 8.75187 4.73516C8.91884 4.63543 9.10881 4.58069 9.30324 4.57628C9.49768 4.57187 9.68993 4.61794 9.86125 4.71L16.015 8.01C16.1936 8.1064 16.3428 8.24931 16.4468 8.42359C16.5508 8.59788 16.6057 8.79705 16.6057 9C16.6057 9.20295 16.5508 9.40212 16.4468 9.57641C16.3428 9.75069 16.1936 9.8936 16.015 9.99ZM9.70375 6.32625L14.6875 9L9.70375 11.6737V6.32625Z",
    fill: "#262626"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1922_5331"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.82251e9151c9c3c4d4d1ad71e8cf0ca7.svg";
export { ForwardRef as ReactComponent };